import {
  Button,
  CloseButton,
  CloseIcon,
  Divider,
  Group,
  Loader,
  NumberFormatter,
  Text,
} from "@mantine/core";
import { useLanguage } from "../../../../../../../stores/LanguageStore";
import { IconFileFilled } from "@tabler/icons-react";
import { downloadBlob } from "../../../../../../../functions/utilFunctions";
import { deleteNoteAttachment } from "../../../../../../../api/PRMAPI";
import { useState } from "react";

const NoteAttachments = ({
  files,
  setFiles,
  isMobile,
  item,
  current,
  isEdit,
}) => {
  const lang = useLanguage((s) => s.language);
  const [loading, setLoading] = useState(false);
  const handleDownload = (attachment) => {
    if (attachment?.download_url) {
      window.open(attachment.download_url, "_blank");
    } else if (attachment?.file) {
      downloadBlob(attachment.file, attachment.filename);
    }
  };

  const handleFileRemove = (attachment) => {
    if (isEdit && attachment.id) {
      setLoading(attachment.id);
      deleteNoteAttachment({
        prospect_id: current.id,
        note_id: item.id,
        attachment_id: attachment.id,
      })
        .then(() => {
          setFiles((prev) => prev.filter((x) => x.name !== attachment.name));
        })
        .finally(() => setLoading(false));
    } else {
      setFiles((prev) => prev.filter((x) => x.name !== attachment.name));
    }
  };

  if (files?.length > 0) {
    return (
      <Group py={8} px={isMobile || !setFiles ? 8 : 0}>
        {files.map((attachment) => (
          <Button
            key={attachment?.id}
            variant="light"
            leftSection={<IconFileFilled size={16} />}
            rightSection={
              setFiles &&
              (loading === attachment.id ? (
                <Loader size={18} />
              ) : (
                <CloseButton
                  onClick={(e) => {
                    e.stopPropagation();
                    handleFileRemove(attachment);
                  }}
                />
              ))
            }
            pl={8}
            tt={"none"}
            radius={"sm"}
            fz={isMobile ? 12 : 14}
            fw={500}
            onClick={() => handleDownload(attachment)}
            size={isMobile ? "xs" : "sm"}
            w={isMobile ? "100%" : undefined}
          >
            {attachment?.name}
            <Text span c={"black"} ml={4}>
              (<NumberFormatter value={(attachment.size / 1024).toFixed(0)} />
              Ko)
            </Text>
          </Button>
        ))}
      </Group>
    );
  }
  return;
};

export default NoteAttachments;
